import Storage from './Storage';
import Utilities from './Utilities';
import SQLStorage from './SQLStorage';
import Bugsnag from '@bugsnag/js'
import axios from 'axios';

import { setSyncStatus, updateSetsOnly } from './state/actions/Calendar'
import store from './state/store';

import { updatedSetsSet } from './state/actions/UpdatedSets';

let MAX_CONCURRENT_DOWN = 20;
const MAX_CONCURRENT_UP = 1;

class Dropbox {

    blockSync(source) {
        // console.log("$$ Blocking Sync " + source);
        window.dropbox.inSync = true;
    }

    unblockSync(source) {
        // console.log("$$- UnBlocking Sync " + source);
        window.dropbox.inSync = false;
    }

    async onConsolidateError() {
        alert(window.ln.consolidateStorageError);
        localStorage.removeItem("consolidateStorage");
        window.location.reload();
    }

    async consolidateStorage() {

        // 1. Archive all cards, and batches

        const consolidateStorageTimestamp = localStorage.getItem("consolidateStorageTimestamp");

        let newFiles = await window.dropbox.api.filesListFolder({path: '', limit: 2000}).catch(e => { 
            this.onConsolidateError();
        });
        if (!newFiles) {
            this.onConsolidateError();
        }
        let allFiles = newFiles.entries;

        while (newFiles.has_more) {
            newFiles = await window.dropbox.api.filesListFolderContinue({cursor: newFiles.cursor}).catch(e => { 
               this.onConsolidateError();
            });
            if (!newFiles) {
                this.onConsolidateError();
            }
            allFiles = allFiles.concat(newFiles.entries)
        }

        allFiles = allFiles.map(item => {
            return item.name
        }).filter(item => item.startsWith("batch-") || item.startsWith("card-"));

        console.log("@@@@ GOING TO MOVE THERE: ", allFiles)

        // 2. Pushing new batches
        let localCards = await SQLStorage.getCards();
        let batches = [];

        let index = 1;
        while (localCards.length > 0) {
            batches.push({
                cards: localCards.splice(0, 2500),
                i: index
            });
            index++;
        }

        console.log("@@@@ Batches: ", batches);

        let promises = [];
        for (let i = 0; i < batches.length; i++) {
            const batch = batches[i];
            promises.push(async function() {
                await window.dropbox.api
                    .filesUpload({path: "/batch-" + batch.i + "-upgraded" + consolidateStorageTimestamp + "-" + batch.cards.length + ".json", contents: new Blob([JSON.stringify(batch.cards)], {type: 'application/json'}), mode: 'overwrite'})
                    .catch((e) => { console.log("@@@@ BATCH FAILED TO SAVE", e); this.onConsolidateError(); });
                console.log("@@@@ BATCH File saved " + batch.i);
            })
        }

        while (promises.length) {
            await Promise.all( promises.splice(0, 3).map(f => f()) )
        }

        // 3. Moving to archive folder
        const timestamp = Utilities.timestamp();
        window.dropbox.api.filesDeleteBatch({
            // "autorename": false,
            "entries": allFiles.filter(item => item.indexOf("-upgraded" + consolidateStorageTimestamp) === -1).map(item => {
                return {
                    // "from_path": "/" + item,
                    // "to_path": "/archived/" + timestamp + "/" + item
                    "path": "/" + item
                }
            })
        }).then(d => {
            console.log("@@@@ Files moved inited", d);
            localStorage.removeItem("consolidateStorage");
            alert(window.length.consolidateStorageDone)
            window.location.reload();
        }).catch(d => {
            console.log("@@@@ Files moved failed", d);
            this.onConsolidateError();
        })

    }

    async startSync() {

        // console.log("@@ startSync");

        if (window.dropbox.inSync) {
            console.log("==already in sync== return")
            return;
        }

        let settings = await Storage.getO("settings");

        if (!settings || !settings.dropbox) {
            return;
        }

        let cursor = settings.dropbox.cursor;

        window.dropbox.blockSync("startSync()");

        // console.log("@@ startSync Actually")

        if (!cursor) {
            this.firstSync();
        } else if (cursor === "in-first-sync") {
            let firstCursor = settings.dropbox.firstCursor;
            let downQueue = await Storage.getO("downQueue")
            if (downQueue.length === 0) {
                settings.dropbox.cursor = firstCursor;
                await Storage.setO("settings", settings);
                window.dropbox.unblockSync("startSync")
                window.dropbox.startSync();
            } else {
                window.dropbox.startQueue();
            }
        } else {

            let upQueue = await Storage.getO("upQueue");
            let downQueue = await Storage.getO("downQueue");

            if (upQueue.length > 0 || downQueue.length > 0) {
                window.dropbox.startQueue();
            } else {
                this.sync();
            }

        }

    }

    async downloadRawFile(filename) {
        
        return new Promise(function(resolve, reject) {

            window.dropbox.api.filesDownload({path: '/' + filename})
                .then(async function(data) {
                    let fr = new FileReader();
                    fr.onload = async function() {
                        resolve(this.result); 
                    };
                    fr.readAsDataURL(data.fileBlob);
                })
                .catch(function(error) { console.log("Failed to download " + filename, error); resolve() });

        })

    }

    async uploadImage(fileName, base64) {

        return new Promise(function(resolve, reject) {

            fetch(base64)
                .then(res => res.blob())
                .then(blob => {

                    window.dropbox.api
                        .filesUpload({path: '/' + fileName, contents: blob, mode: 'overwrite'})
                        .then(function(response) {

                            // console.log("===File Uploaded - Done===", response);
                            // resolve(response)

                            window.dropbox.api
                            .sharingCreateSharedLink({path: '/' + fileName})
                                .then(function(response) {
                                    // console.log("===Adjustung ACL - Done===", response)
                                    let url = response.url;
                                    url = url.replace("dl=0", "raw=1")
                                    // console.log(url, "<<<<<<<<<<<<<FINAL URL");
                                    resolve(url)
                                }).catch(e => {
                                    // console.log("Failed to update ACL", e);
                                    Bugsnag.notify(e);
                                    reject(e);
                                })

                        })
                        .catch(function(error) {
                            if (error.response.status === 401) {
                                this.reauth("source");
                                return;
                            }
                            Bugsnag.notify(error);
                            reject(error)
                        });

                })

        })
    
    }

    async reauth(source) {
        let settings = await Storage.getO("settings");

        console.log(settings, "<<<,");
        // return;

        if (!settings.dropbox.refreshToken) {
            window.startDropboxAuth();
            window.dropbox.unblockSync("sync()");
            console.log("_____needs full reauth from user for the first time");
        } else {
            console.log("___attempt to get refresh token wiht " + settings.dropbox.refreshToken);
            axios({
                method: "POST",
                url: "https://api.dropboxapi.com/oauth2/token?grant_type=refresh_token&refresh_token=" + settings.dropbox.refreshToken + "&client_id=k0eex5o1kl2nhrz",
            }).then( async (response) => {
                window.dropbox.unblockSync("sync()");
                if (response && response.data && response.data.access_token) {
                    console.log("___ Got fresh token " + response.data.access_token);
                    settings.dropbox.key = response.data.access_token;
                    let res = await Storage.setO("settings", settings);
                    localStorage.removeItem("externalAuthStarted");
                    window.initDropbox();
                }
            })
            .catch(async function (error) {
                console.log(error);
            });
        }
    }

    async sync() {

        console.log("sync");

        if (!window.dropbox || !window.dropbox.api || localStorage.getItem("externalAuthStarted"))
            return;

        let settings = await Storage.getO("settings");

        if (settings.dropbox.cursor === "in-first-sync") {
            window.dropbox.unblockSync("sync()");
            return;
        }

        store.dispatch(setSyncStatus("Checking for updates"))

        let newFiles = await window.dropbox.api.filesListFolderContinue({cursor: settings.dropbox.cursor}).catch((e) => {
            if (e.response.status === 401) {
                this.reauth();
                return;
            }
            Bugsnag.notify(e)
            console.error("Error getting updates", e);
            store.dispatch(setSyncStatus("Connection Error"))
            window.dropbox.unblockSync("sync()");
        });

        // console.log("@@@@ NEW FILE TO DONWLOAD", newFiles)

        if (!newFiles) {
            window.dropbox.unblockSync("sync()");
            return;
        }

        let allFiles = newFiles.entries;
        let allAreDeleted = true;

        while (newFiles.has_more) {
            newFiles = await window.dropbox.api.filesListFolderContinue({cursor: newFiles.cursor}).catch((e) => { 
                if (e.response.status === 401) {
                    this.reauth();
                    return;
                }
                Bugsnag.notify(e); console.error("Error getting updates", e);
            });
            if (!newFiles) {
                window.dropbox.unblockSync("sync()");
                return;
            }
            allFiles = allFiles.concat(newFiles.entries)
        }

        if (allFiles.length > 0) {

            let queueForDownloadList = [];

            for (let i = 0; i < allFiles.length; i++) {

                let fileName = allFiles[i].name.replace(".json", "").split("-");

                if (allFiles[i]['.tag'] === "deleted") {

                    switch (fileName[0]) {
                        case "card":
                            let cardId = fileName[2];
                            await SQLStorage.deleteCard(cardId);
                            break;
                        case "set":
                            let studysetId = fileName[1];
                            await SQLStorage.deleteSet(studysetId);
                            break;
                        case "tag":
                            let tagId = fileName[1];
                            await SQLStorage.deleteTag(tagId);
                            break;
                        default: break;
                    }

                } else {

                    allAreDeleted = false;

                    switch (fileName[0]) {
                        case "card": queueForDownloadList.push(["card", fileName[1] + "-" + fileName[2]]); break;
                        case "set": queueForDownloadList.push(["set", fileName[1]]); break;
                        case "tag": queueForDownloadList.push(["tag", fileName[1]]); break;
                        case "batch": queueForDownloadList.push(["batch", fileName[1] + "-" + fileName[2] + (fileName[3] ? ("-" + fileName[3]) : "")]); break;
                        case "setting": queueForDownloadList.push(["setting", fileName[1]]); break;
                        default: break;
                    }

                }

            }

            await window.dropbox.queueForDownload(queueForDownloadList);

            settings.dropbox.cursor = newFiles.cursor;
            await Storage.setO("settings", settings);

        }

        window.dropbox.unblockSync("sync()");

        if (allFiles.length > 0 && !allAreDeleted) {
            window.dropbox.startQueue();
        } else {
            store.dispatch(setSyncStatus("Updated at " + Utilities.timestamp()))
            const deletedUnSettedCards =  await SQLStorage.getAndDeleteCardsWithoutSets();
            if (deletedUnSettedCards) {
                window.loadInitStudysets();
            }
        }

    }

    async firstSync() {

        store.dispatch(setSyncStatus("Retriving card indexes"));

        if (!window.dropbox.api) {
            setTimeout(() => {
                this.firstSync();
            }, 250);
            return;
        }

        let newFiles = await window.dropbox.api.filesListFolder({path: '', limit: 2000}).catch(e => { 
            if (e.response.status === 401) {
                this.reauth();
                return;
            }
            Bugsnag.notify(e)
        });
        if (!newFiles) {
            window.dropbox.unblockSync("sync()");
            return;
        }
        let allFiles = newFiles.entries;

        while (newFiles.has_more) {
            newFiles = await window.dropbox.api.filesListFolderContinue({cursor: newFiles.cursor}).catch(e => { 
                if (e.response.status === 401) {
                    this.reauth();
                    return;
                }
                Bugsnag.notify(e) 
            });
            if (!newFiles) {
                window.dropbox.unblockSync("sync()");
                return;
            }
            allFiles = allFiles.concat(newFiles.entries)
        }

        allFiles = allFiles.map(item => {
            return item.name
        })

        allFiles = allFiles.reverse();

        let localCards = await SQLStorage.getCards();
        let localTags = await SQLStorage.getTags();
        let localSets = await SQLStorage.getStudysets();
        let localSettings = await SQLStorage.getSettings();

        let queueForUploadList = []

        if (allFiles.indexOf("setting-spacedRepetitionCycles.json") === -1) {
            for (let i = 0; i < localSettings.length; i++) {
                queueForUploadList.push(["setting", localSettings[i].key])
            }
        }

        for (let i = 0; i < localSets.length; i++) {
            if (allFiles.indexOf("set-" + localSets[i].id + ".json") === -1) {
                queueForUploadList.push(["set", localSets[i].id]);
            }
        }

        for (let i = 0; i < localTags.length; i++) {
            if ( (allFiles.indexOf("tag-" + localTags[i].id + ".json") === -1) && (localTags[i].id !== "star") && (localTags[i].id !== "learnt") && (localTags[i].id !== "strength-1") && (localTags[i].id !== "strength-2") && (localTags[i].id !== "strength-3") && (localTags[i].id !== "strength-4") && (localTags[i].id !== "strength-5") ) {
                queueForUploadList.push(["tag", localTags[i].id])
            }
        }

        for (let i = 0; i < localCards.length; i++) {
            if (allFiles.indexOf("card-" + localCards[i].id + "-" + localCards[i].setId + ".json") === -1) {
                queueForUploadList.push(["card", localCards[i].id + "-" + localCards[i].setId])
            }
        }

        await window.dropbox.queueForUpload(queueForUploadList);

        let types = { card: [], set: [], tag: [], setting: [], batch: [] };
        
        for (let i = 0; i < allFiles.length; i++) {
            if (allFiles[i].startsWith("card")) types.card.push(allFiles[i]);
            else if (allFiles[i].startsWith("setting")) types.setting.push(allFiles[i]);
            else if (allFiles[i].startsWith("set")) types.set.push(allFiles[i]);
            else if (allFiles[i].startsWith("tag")) types.tag.push(allFiles[i]);
            else if (allFiles[i].startsWith("batch")) types.batch.push(allFiles[i]);
        }

        allFiles = types.set.concat(types.setting, types.tag, types.card, types.batch);

        console.log("@@@@@ALL FILES: ", allFiles);

        if (allFiles.length !== 0) {

            let queueForDownloadList = [];

            for (let i = 0; i < allFiles.length; i++) {

                let file = allFiles[i].replace(".json", "").split("-");
    
                switch (file[0]) {
                    case "card": queueForDownloadList.push(["card", file[1] + "-" + file[2]]); break;
                    case "set": queueForDownloadList.push(["set", file[1]]); break;
                    case "tag": queueForDownloadList.push(["tag", file[1]]); break;
                    case "batch": queueForDownloadList.push(["batch", file[1] + "-" + file[2] + (file[3] ? ("-" + file[3]) : "")]); break;
                    case "setting": queueForDownloadList.push(["setting", file[1]]); break;
                    default: break;
                }
    
            }

            await window.dropbox.queueForDownload(queueForDownloadList);

        }

        let settings = await Storage.getO("settings");
        settings.dropbox.cursor = "in-first-sync";
        settings.dropbox.firstCursor = newFiles.cursor;
        await Storage.setO("settings", settings);
        store.dispatch(setSyncStatus("Updated at " + Utilities.timestamp()))
        window.dropbox.unblockSync("firstSync()");

        window.dropbox.startQueue();

    }

    async queueForUpload(type, id) {

        // console.log("@@@2 queueForUpload() " + type + " " + id)

        if (!window.dropbox.api)
            return;

        if (typeof type !== "string") {
            // console.log("@@@@@@@@ ARRW OF DOWNLODS @@@@@@@@@");
            let upQueue = await Storage.getO("upQueue");
            for (let i = 0; i < type.length; i++) {
                const typeA = type[i][0];
                const idA = type[i][1];
                let dupe = upQueue.indexOf(typeA + "-" + idA);
                if ( (dupe !== -1) && ( (!window.dropbox.thisWave) || (window.dropbox.thisWave.indexOf(typeA + "-" + idA) === -1) ) ) {
                    // only remove if not already in sync, if in sync leave and save again
                    upQueue.splice(dupe, 1);
                }
                upQueue.push(typeA + "-" + idA);
            }
            await Storage.setO("upQueue", upQueue, 2);
        } else {
            // console.log("@@@@@@@@ NORMAL DOWNLODS @@@@@@@@@");
            if (id.indexOf("undefiend") !== -1)
                return;
            let upQueue = await Storage.getO("upQueue");
            let dupe = upQueue.indexOf(type + "-" + id);
            if ( (dupe !== -1) && ( (!window.dropbox.thisWave) || (window.dropbox.thisWave.indexOf(type + "-" + id) === -1) ) ) {
                // only remove if not already in sync, if in sync leave and save again
                upQueue.splice(dupe, 1);
            }
            upQueue.push(type + "-" + id);
            await Storage.setO("upQueue", upQueue, 3);
        }

        window.dropbox.debounce();

    }

    debounce(actuallyStart) {

        if (actuallyStart) {
            clearTimeout(window.dropbox.debounceTimeout);
            window.dropbox.debounceTimeout = setTimeout(function() {
                // console.log("Debounced after 1500 seconds of inactivity");
                window.dropbox.startSync();
            }, 300);
        } else {
            return;
        }

    }

    async queueForDownload(type, id) {

        if (!window.dropbox.api)
            return;

        if (typeof type !== "string") {
            // console.log("@@@@@@@@ ARRW OF DOWNLODS @@@@@@@@@");
            let downQueue = await Storage.getO("downQueue");
            let soFar = [];
            for (let i = 0; i < type.length; i++) {
                const typeA = type[i][0];
                const idA = type[i][1];
                const hash = typeA + idA;
                if (soFar.indexOf(hash) !== -1) {
                    continue;
                } else {
                    soFar.push(hash);
                }
                let dupe = downQueue.indexOf(typeA + "-" + idA);
                if ( (dupe !== -1) && (window.dropbox.thisWave && window.dropbox.thisWave.indexOf(typeA + "-" + idA) === -1) ) {
                    // only remove if not already in sync, if in sync leave and save again
                    downQueue.splice(dupe, 1);
                }
                downQueue.push(typeA + "-" + idA);
            }
            await Storage.setO("downQueue", downQueue);
        } else {
            // console.log("@@@@@@@@ NORMAL DOWNLODS @@@@@@@@@");
            if (id.indexOf("undefiend") !== -1)
                return;
            let downQueue = await Storage.getO("downQueue");
            let dupe = downQueue.indexOf(type + "-" + id);
            if ( (dupe !== -1) && (window.dropbox.thisWave && window.dropbox.thisWave.indexOf(type + "-" + id) === -1) ) {
                // only remove if not already in sync, if in sync leave and save again
                downQueue.splice(dupe, 1);
            }
            downQueue.push(type + "-" + id);
            await Storage.setO("downQueue", downQueue);
        }

        window.dropbox.debounce();

    }

    async startQueue(startNow) {

        if (!window.dropbox.api) {
            return
        }

        if (!startNow) {
            // console.log("startQueue() delayed")
            clearTimeout(window.dropbox.startQueueTimeout);
            window.dropbox.startQueueTimeout = setTimeout(function() {
                window.dropbox.startQueue(true);
            }, 1000);
            return;
        }

        // console.log("startQueue() started finally")

        let upQueue = await Storage.getO("upQueue");
        let downQueue = await Storage.getO("downQueue");

        let all = upQueue.concat(downQueue);
        // let inSyncStudysets = [...new Set( all.filter(item => {
        //     let parts = item.split("-");
        //     if (parts[0] === "card") {
        //         return true;
        //     }
        //     return false
        // }).map(item => item.split("-")[2]))]

        let inSyncStudysets = [];

        for (let i = 0; i < all.length; i++) {
            const parts = all[i].split("-");
            if (parts[0] === "batch") {
                let setIds = parts[2].split("|");
                //  console.log("BATCH", setIds)
                for (let j = 0; j < setIds.length; j++) {
                    if (inSyncStudysets.indexOf(setIds[j]) === -1) {
                        inSyncStudysets.push(setIds[j])
                    }
                }
            }
        }
        
        const reduxStudysets = store.getState().calendar
        let studysetsFormatted = (reduxStudysets && reduxStudysets.studysetsFormatted) ? reduxStudysets.studysetsFormatted : [] ;

        if (studysetsFormatted && inSyncStudysets) {
            for (let i = 0; i < studysetsFormatted.length; i++) {
                if (
                    inSyncStudysets.indexOf(studysetsFormatted[i].id.substring(studysetsFormatted[i].id.length - 3)) !== -1 ||
                    inSyncStudysets.indexOf(studysetsFormatted[i].id) !== -1 ||
                    inSyncStudysets.indexOf("upgraded") !== -1
                ) {
                    studysetsFormatted[i].isSyncing = true;
                } else {
                    studysetsFormatted[i].isSyncing = false;
                }
            }
        }

        store.dispatch(updateSetsOnly(studysetsFormatted))

        if (upQueue.length !== 0) {

            store.dispatch(setSyncStatus("Uploading " + (upQueue.length)));

            let cardsTobeCleared = [];

            if (upQueue[0].startsWith("card")) {
                upQueue.unshift("batch-" + Utilities.timestamp())
                cardsTobeCleared = upQueue.filter(item => item.startsWith("card"));
                upQueue = upQueue.filter(item => !item.startsWith("card"));
            }

            // console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ Uploading updates ALL CARDS: ", upQueue)

            window.dropbox.thisWave = upQueue.splice(0, MAX_CONCURRENT_UP);

            new Promise(function(resolve, reject) {

                let i = 0;

                for (let i = 0; i < window.dropbox.thisWave.length; i++) {
                    window.dropbox
                        .uploadFile(window.dropbox.thisWave[i].split("-")[0], window.dropbox.thisWave[i].split("-")[1], window.dropbox.thisWave[i].split("-")[2], window.dropbox.thisWave[i].split("-")[0] === "batch" ? cardsTobeCleared.length : undefined)
                        .then(function() { i++; if (i === window.dropbox.thisWave.length) { resolve() } })
                        .catch(function(e) { console.log("ERROR", e); reject(); })
                }

            }).then(async function() {

                // Queue before sync - might have new cards
                let oldOrNewQueue = await Storage.getO("upQueue");
                if (cardsTobeCleared && cardsTobeCleared.length !== 0) {
                    // GO over queue, see if there is anything not saved here
                    for (let i = 0; i < oldOrNewQueue.length; i++) {
                        const element = oldOrNewQueue[i];
                        if ( (element.startsWith("card") && cardsTobeCleared.indexOf(element) === -1) || (!element.startsWith("card") && upQueue.indexOf(element) === -1) ) {
                            upQueue.push(element);
                        }
                    }
                    await Storage.setO("upQueue", upQueue, 1);
                } else {
                    upQueue = await Storage.getO("upQueue");
                    upQueue.splice(0, window.dropbox.thisWave.length);
                    await Storage.setO("upQueue", upQueue, 1);
                }

                // console.log("Saved upQueue")
                if (upQueue.length === 0) {
                    store.dispatch(setSyncStatus("Updated at " + Utilities.timestamp()))
                }
                window.dropbox.unblockSync("startQueue()");
                window.dropbox.startSync();
            }).catch(function(err) {
                // console.log("==== A problem occured while uploading files", err);
                store.dispatch(setSyncStatus("Connection Error"))
                window.dropbox.unblockSync("startQueue()");
            })


        } else if (downQueue.length !== 0) {

            store.dispatch(setSyncStatus("Downloading " + downQueue.length))

            window.dropbox.thisWave = [];
            let firstType = downQueue[0].split("-")[0];
            let currentType = downQueue[0].split("-")[0];

            do {

                let newSlot = downQueue.splice(0, 1)[0];
                if (!newSlot) {
                    break;
                }

                currentType = newSlot.split("-")[0]
                if (firstType !== currentType) {
                    downQueue.unshift(newSlot);
                    break;
                }

                if (window.dropbox.thisWave.length === MAX_CONCURRENT_DOWN) {
                    downQueue.unshift(newSlot);
                    break;
                }

                window.dropbox.thisWave.push(newSlot);
                currentType = window.dropbox.thisWave[window.dropbox.thisWave.length-1].split("-")[0]

                if (currentType === "batch" && newSlot.indexOf("-upgraded") !== -1) {
                    break
                }

            } while (true)

            console.log("@@@@ DOWNLOADING ", downQueue)

            new Promise(function(resolve, reject) {

                let downlaodedCount = 0;
                let changedSets = [];
                let updates = [];
                // let batches = [];
                let cardsCache = {};

                for (let i = 0; i < window.dropbox.thisWave.length; i++) {
                    window.dropbox
                        .downloadFile(window.dropbox.thisWave[i].split("-")[0], window.dropbox.thisWave[i].split("-")[1], window.dropbox.thisWave[i].split("-")[2], window.dropbox.thisWave[i].split("-")[3])
                        .then(async function(res) {

                            let changedSet = res[0];

                            if (res[1] && res[2] && res[3]) {
                                updates.push([res[1], res[2], res[3]]);
                            }

                            downlaodedCount++; 

                            if (changedSet && changedSets.indexOf(changedSet) === -1) {
                                changedSets.push(changedSet);
                            }

                            // console.log(downlaodedCount + " of " + window.dropbox.thisWave.length)

                            if (downlaodedCount === window.dropbox.thisWave.length) {

                                // console.log("================================ DONE DOWNLOADING NOW PROCESSING ALL =======================================");

                                for (let j = 0; j < updates.length; j++) {

                                    const element = updates[j];
                                    const type = element[0];
                                    const data = element[1];
                                    const batchId = element[2];

                                    if (type === "card" || type === "batch") {

                                        for (let i = 0; i < data.length; i++) {

                                            const element = data[i];

                                            if (cardsCache[element.id] && (!(cardsCache[element.id].updatedAtTimestamp < element.updatedAtTimestamp))) {
                                                continue;
                                            }

                                            let localCard = await SQLStorage.getCard(element.id);
                                            let localUpdatedAt = localCard ? localCard.updatedAtTimestamp : null;
                                            let serverUpdatedAt = element.updatedAtTimestamp || null
                
                                            if (!localCard) {
                                                cardsCache[element.id] = element;
                                            } else if (localUpdatedAt < serverUpdatedAt) {
                                                cardsCache[element.id] = element;
                                            }

                                            if (changedSets.indexOf(element.setId) === -1) {
                                                changedSets.push(element.setId);
                                            }
            
                                        }

                                    }

                                }

                                await SQLStorage.saveCard(Object.values(cardsCache), true, true);

                                resolve([...new Set(changedSets)])

                            } 

                        })
                        .catch(function(error) { 
                            Bugsnag.notify(error); 
                            console.log("ERROR", error); 
                            if (error.error && (error.error.indexOf("path_lookup/not_found/") !== -1 || error.error.indexOf("path/not_found/") !== -1)) {
                                console.log("GRACEFUL RESOLVE");
                                resolve();
                            } else {
                                reject();
                            }
                        })
                }

            }).then(async function(changedSets) {
                
                // console.log("================================ Successful download all, can delete all =======================================");

                // console.log("@@@@@==================@@@@@ CHANGED SETS", changedSets);

                downQueue = await Storage.getO("downQueue");
                downQueue.splice(0, window.dropbox.thisWave.length);
                await Storage.setO("downQueue", downQueue);
                store.dispatch(updatedSetsSet(changedSets))
                if (downQueue.length === 0) {
                    store.dispatch(setSyncStatus("Updated at " + Utilities.timestamp()))
                }
                window.dropbox.unblockSync("startQueue()");
                window.dropbox.startSync();
            }).catch(function(err) {
                if (err && err.status === 409) {
                    console.log("====== probably deleted issue ====== RESOLVE NOW -ahhh not that easy")
                    console.log("==== A problem occured while uploading files", err);
                } else {
                    console.log("==== A problem occured while uploading files", err);
                    store.dispatch(setSyncStatus("Connection Error"))
                    window.dropbox.unblockSync("startQueue()");
                }
            })

        } else {
            window.dropbox.startSync();
        }

    }

    downloadFile(type, id, secondaryId, thirdlyId) {

        return new Promise(async (resolve, reject) => {

            let fileName = null;

            if (type === "card") {
                fileName = "card-" + id + "-" + secondaryId + ".json";
            } else if (type === "tag") {
                fileName = "tag-" + id + ".json";
            } else if (type === "set") {
                fileName = "set-"+ id + ".json";
            } else if (type === "setting") {
                fileName = "setting-"+ id + ".json";
            } else if (type === "batch") {
                fileName = "batch-"+ id + "-" + secondaryId + (thirdlyId ? ("-" + thirdlyId) : "") + ".json";
            } else {
                return reject("Unknown type");
            }

            // console.log("Just downloading " + fileName + "(" + type + ")")

            // console.log(fileName + " STARTED DOWNLOADING");

            window.dropbox.api
                .filesDownload({path: '/' + fileName})
                .then(async function(data) {

                    // console.log("DOWNLAODED: " + fileName)

                    let fr = new FileReader();

                    fr.onload = async function() {

                        let data = JSON.parse(this.result);

                        // if (data.emoji !== undefined) {
                        //     data.emoji = decodeURIComponent(data.emoji);
                        // }

                        if (type === "tag") {

                            let localTag = await SQLStorage.getTag(data.id);
                            let localUpdatedAt = localTag ? Utilities.iOSFixDate(localTag.updatedAt) : null;
                            let serverUpdatedAt = Utilities.iOSFixDate(data.updatedAt);

                            if  (!localTag) {
                                await SQLStorage.saveTag(data);
                            } else if (localUpdatedAt <= serverUpdatedAt) {
                                await SQLStorage.saveTag(data);
                            }

                            return resolve(["all"]) // will this wrok?

                        } else if (type === "set") {

                            let localSet = await SQLStorage.getCard(data.id);
                            let localUpdatedAt = localSet ? Utilities.iOSFixDate(localSet.updatedAt) : null;
                            let serverUpdatedAt = Utilities.iOSFixDate(data.updatedAt);

                            if  (!localSet) {
                                await SQLStorage.saveSet(data);
                            } else if (localUpdatedAt <= serverUpdatedAt) {
                                await SQLStorage.saveSet(data);
                            }

                            return resolve([data.id]);

                        } else if (type === "card" || type === "batch") {

                            if (type === "card") {
                                data = [data];
                            }

                            return resolve([secondaryId, type, data, id]);

                        } else if (type === "setting") {

                            // console.log("=====>>>>>>SAVING SETTING")
                            await SQLStorage.saveSetting(id, data);
                            window.activationCheck();

                        } else {
                            return reject("Unknown type")
                        }

                        resolve([]);

                    };

                    fr.readAsText(data.fileBlob);

                })
                .catch((e) => {
                    if (e.response && e.response.status === 401) {
                        this.reauth();
                        return;
                    }
                    Bugsnag.notify(e)
                    reject(e)
                });

        })

    }

    async uploadFile(type, id, sId, thirdlyId) {

        return new Promise(async (resolve, reject) => {

            let content = null;
            let fileName = null;
            let blob = null;

            if (type === "card") {
                content = await SQLStorage.getCard(id);
                fileName = "card-" + id + "-" + sId + ".json";
            } else if (type === "tag") {
                content = await SQLStorage.getTag(id);
                fileName = "tag-" + id + ".json";
            } else if (type === "set") {
                content = await SQLStorage.getStudyset(id);
                fileName = "set-"+ id + ".json";
            } else if (type === "setting") {
                content = await SQLStorage.getSetting(id);
                fileName = "setting-"+ id + ".json";
            } else if (type === "batch") {
                let upQueue = await Storage.getO("upQueue");
                upQueue = upQueue.filter(item => item.startsWith("card")).map(item => item.split("-")[1]);
                // console.log("ALL CARDS NOT SYNCED: ", upQueue);
                let contentObj = await SQLStorage.getCardsByIds(upQueue);
                content = [];

                for (let i = 0; i < upQueue.length; i++) {
                    let cardId = upQueue[i];
                    let card = contentObj[cardId];
                    if (!card) {
                        content.push({
                            id: cardId,
                            deleted: "t",
                            setId: "null",
                            updatedAtTimestamp: Utilities.timestamp()
                        })
                    } else {
                        card.setId = card.setId || "null";
                        content.push(card);
                    }
                }

                let setIds = [...new Set(content.map(item => item.setId))];

                fileName = "batch-"+ id + "-" + setIds.slice(0, 18).map(item => item.substring(item.length - 3)).join("|") + (thirdlyId ? ("-" + thirdlyId) : "") + ".json";
            } else {
                return reject("Unknown type");
            }

            // console.log("@@@@@@@@@@@@@@@ UPLOAD FILE " + type + " " + id, content);

            if (!fileName) {
                return reject("No file path");
            }

            if (content) {

                blob = new Blob([JSON.stringify(content)], {type: 'application/json'})
                // console.log("Just uploading " + fileName, content)

                window.dropbox.api
                    .filesUpload({path: "/" + fileName, contents: blob, mode: 'overwrite'})
                    .then(function(response) { resolve("File saved"); })
                    .catch((e) => { 
                        if (e.response.status === 401) {
                            this.reauth();
                            return;
                        }
                        Bugsnag.notify(e); reject("Failed to save file", e)
                    });

            } else {

                window.dropbox.api
                    .filesDelete({path: "/" + fileName})
                    .then(function(response) {
                        resolve("File deleted");
                    })
                    .catch((error) => {
                        if (error.response.status === 401) {
                            this.reauth();
                            return;
                        }
                        Bugsnag.notify(error);
                        if (error && error.error && (error.error.error_summary.indexOf("path_lookup/not_found/") !== -1 || error.error.error_summary.indexOf("path/not_found/") !== -1)) {
                            console.log("Failed to delete - probably deleted manually - NOW RESOLVING");
                            resolve();
                        } else {
                            console.log("Failed to delete - probably no internet");
                            reject(error);
                        }
                    });

            }

        })

    }

}

export default Dropbox;
